import type { PodBrand } from '@/types/pod'

/**
 * The Oxydise pod — branding layer.
 *
 * This is niche-specific config, deliberately isolated from the engine.
 * Contact details are Oxydise's real public ones (used when the assistant
 * defers a question to a human, e.g. medical screening).
 *
 * Batch B (19 Jul 2026): the five UI strings the chat surface renders moved
 * from hardcoded engine copy onto the pod contract. The values below are the
 * EXACT wording previously hardcoded in src/App.tsx — behaviour unchanged for
 * Oxydise; the engine is simply niche-clean now.
 */
export const oxydisePod: PodBrand = {
  id: 'oxydise',
  brandName: 'Oxydise',
  productName: 'Oxydise Onboarding Assistant',
  assistantName: 'Oxy',
  tagline: 'Your hyperbaric chamber setup and onboarding helper.',
  roleLabel: 'onboarding assistant',
  welcomeIntro:
    'I can help you get set up with your Oxydise chamber — pricing, delivery, fitting it into your space, and how sessions work. What would you like to know?',
  starters: [
    'How much does a chamber cost?',
    'What is hyperbaric oxygen therapy?',
    'Will it fit in my home?',
    'How does a session work?',
  ],
  inputPrompt: 'Ask Oxy about your chamber',
  footerNote:
    "Oxy answers from Oxydise's published guidance. For medical questions, contact the Oxydise clinical team.",
  theme: {
    // EXACT values from src/index.css — Oxydise is the palette those defaults
    // were written for, so this pod's rendering is unchanged by Batch C.
    '--color-brand-primary': '13 110 138',
    '--color-brand-primary-hover': '9 84 107',
    '--color-brand-accent': '94 197 210',
    '--color-surface-base': '247 250 251',
    '--color-surface-raised': '255 255 255',
    '--color-surface-subtle': '237 244 246',
    '--color-text-primary': '17 32 39',
    '--color-text-muted': '90 110 119',
    '--color-text-danger': '178 47 47',
    '--color-border-subtle': '218 230 233',
  },
  contact: {
    phone: '01223 657444',
    email: 'hello@oxydise.co.uk',
    whatsapp: '+447535436909',
  },
}
